import * as React from 'react';
import { LinkIcon } from '../Icons';
import './Heading.styles.scss';

export interface HeadingProps {
  children: string;
  type: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

/**
 * Converts inner HTML text into a formatted ID selector for on-page anchor tags
 */
export function getAnchor(text?: string | string[]): string {
  let t = Array.isArray(text) ? text.find((i) => typeof i === 'string') : text;
  if (!t) return '';
  return t
    .toLowerCase()
    .replace(/[^-a-z0-9 ]/g, '')
    .replace(/[ ]/g, '-');
}

export const Heading = ({ children, type }: HeadingProps) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const anchor = getAnchor(children);

  function copyToClipboard(value: string) {
    const path = window.location.href.split('#')[0];
    navigator.clipboard.writeText(`${path}#${value}`);
  }

  return (
    <div className="mdx-heading">
      {React.createElement(type, { id: anchor }, children)}
      <button
        onClick={() => {
          copyToClipboard(anchor);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 3000);
        }}>
        <LinkIcon />
        <span className={isCopied ? 'active' : undefined}>Copied URL</span>
      </button>
    </div>
  );
};
